import React from "react";
import Head from "next/head";
import PageName from "../../components/pagename";
import ProjectsComp from "../../components/projects";
import Contact_us from "../../components/contact_us/index";
import { useTranslations } from "next-intl";
import axios from "../../Axios/index";
export default function Projects({ result }) {
  const t = useTranslations("projects");
  return (
    <>
      <Head>
        <title>Projects | Ascot Enterprise Solutions </title>
      </Head>
      <div>
        <PageName title={t("PROJECTS")} img="career/Lightbulb" />
        <ProjectsComp data={result} />
        <Contact_us />
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  try {
    const { data } = await axios.get(`user/project/all-Project`);
    const result = data.result;
    return {
      props: {
        result,
        messages: require(`../../locales/${context.locale}.json`),
      },
    };
  } catch (error) {
    return { props: { blogData: false } };
  }
}
